import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
export default function AdminDashboard() {
    const [classes, setClasses] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        (async () => {
            const { classes } = await api.get("/api/classes");
            const enriched = [];
            for (const k of classes) {
                const [{ students }, { exams }] = await Promise.all([
                    api.get(`/api/classes/${k.id}/students`),
                    api.get(`/api/classes/${k.id}/exams`),
                ]);
                enriched.push({ ...k, students: students.length, exams: exams.length });
            }
            setClasses(enriched);
            setLoading(false);
        })();
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "eyebrow", children: "Admin" }), _jsx("h1", { className: "font-display text-3xl mb-5 mt-1", children: "Overview" }), loading ? (_jsx("p", { className: "text-slate2 text-sm", children: "Loading\u2026" })) : (_jsx("div", { className: "grid gap-3 sm:grid-cols-2 lg:grid-cols-3", children: classes.map((k) => (_jsxs(Link, { to: `/admin/students?class=${k.id}`, className: "card p-5 hover:bg-paper transition", children: [_jsx("div", { className: "font-display text-xl", children: k.name }), _jsxs("div", { className: "text-slate2 text-xs mt-1", children: [_jsx("span", { className: "font-mono text-ink text-lg", children: k.students }), " students \u00B7", " ", _jsx("span", { className: "font-mono text-ink", children: k.exams }), " exams"] })] }, k.id))) }))] }));
}
